import { ContentState, convertToRaw, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Label, Stack, Text } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { Editor } from "react-draft-wysiwyg";
import { Immocom } from '../../specifique/immocom';

export class EUIRichTextField extends Component {

    static defaultProps = {
        label: undefined,
        afficherNbCaracteresRestants: true,
        disabled: false,
        maxLength: undefined,
        onBlur: undefined,
        onChange: undefined, // (event, newValue) => null
        onDelayedChange: undefined, // (event, newValue) => null
        onFocus: undefined,
        required: false,
        toolbar: { options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'history', 'link'] },
        value: "",
    };

    static defaultState = {
        //editorState: EditorState.createEmpty(),
        hasFocus: false,
    };

    constructor() {
        super();
        this.state = { ...EUIRichTextField.defaultState };
        this.delayedChange = window.setTimeout(null);
    };

    _setEditorState = (value) => {
        const draft = htmlToDraft(value);
        const { contentBlocks, entityMap } = draft;
        const content = ContentState.createFromBlockArray(contentBlocks, entityMap);
        this.setState({ editorState: EditorState.createWithContent(content) });
    };

    _onBlur = (event) => {
        const { onBlur } = this.props;
        this.setState({ hasFocus: false });
        if (!!onBlur && typeof onBlur === "function") onBlur(event);
    };

    _onEditorStateChange = (editorState) => {
        // Méthode déclenché à la saisie mais aussi au focus, au déplacement du curseur, etc.
        // On teste donc si le texte a réellement changé ou non
        this.setState({ editorState });
        const { onChange, onDelayedChange, value } = this.props;

        if (typeof onChange === "function") {
            let newValue = draftToHtml(convertToRaw(editorState.getCurrentContent()));
            if (newValue.endsWith("\n")) newValue.slice(0, -2);
            if (newValue !== value) {
                onChange(null, newValue);
                if (typeof onDelayedChange === "function") {
                    window.clearTimeout(this.delayedChange);
                    const handler = () => onDelayedChange(null, newValue);
                    this.delayedChange = window.setTimeout(handler, 750);
                }
            }
        }
    };

    _onFocus = (event) => {
        const { onFocus } = this.props;
        this.setState({ hasFocus: true });
        if (typeof onFocus === "function") onFocus(event);
    };

    _onRenderLabel = () => {

        const { afficherNbCaracteresRestants, disabled, label, maxLength, required, value } = this.props;
        const { hasFocus } = this.state;
        const defaultLabel = <Label required={required}>{label}</Label>;

        if (hasFocus && afficherNbCaracteresRestants && !!label && !disabled && !!maxLength && Number.isInteger(maxLength)) {
            const nbCarRestants = Immocom.fiche().getNbCarRestants(value, maxLength);
            return <Stack horizontal horizontalAlign="space-between" verticalAlign="end">
                {defaultLabel}
                <Text variant="small">{`${nbCarRestants}/${maxLength}`}</Text>
            </Stack>
        }
        else return defaultLabel;

    };

    componentDidMount = () => {
        const { value } = this.props;
        if (!!value)
            this._setEditorState(value);
    };

    // Dans le cas d'un chargement différé
    componentDidUpdate = (prevProps) => {
        const { value } = this.props;
        if (!prevProps.value && !!value)
            this._setEditorState(value);
    };

    render = () => {

        const { label } = this.props;
        const { editorState } = this.state;

        return <>
            {!!label && this._onRenderLabel()}
            <Editor
                {...this.props}
                editorState={editorState}
                onBlur={this._onBlur}
                onChange={null} // Conflictuel avec onChange utilisé dans this._onEditorStateChange
                onEditorStateChange={this._onEditorStateChange}
                onFocus={this._onFocus}
            />
        </>;

    };

}